import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import i18n from "i18n";

import { StockService } from "services/StockService";
import { PublicService } from "services/PublicService";
import useRequest from "hooks/useRequest";

import AdminLayout from "components/MainApp/layouts/DesktopLayout";
import Loader from "components/MainApp/atoms/Loader";
import ErrorModal from "components/MainApp/organisms/Stock/ErrorModal";
import LocalizationProductFilter from "./LocalizationProductFilter";

import styles from  "./LocalizationProduct.module.scss";
import LocalizationProductItem from "../../../../shared/components/LocalizationProductItem";
import DropDownTags from "shared/components/drop-down/DropDownTags";

import { Container, Grid } from "@material-ui/core";
import { stepLocalizations } from "views/Admin/ExtraMenu/data/stepLocalizations";
import { NotFoundItems } from "views/Admin/components/NotFoundItems";
import IconSearchProducts from "assets/images/icon-search-products.svg";

export const LocalizationProductView = () => {
  const history = useHistory();
  const [mobilePanelOpen, setMobilePanelOpen] = useState(false);
  const paginationSize = 10;
  const [itemId, setItemId] = useState(null);
  const [listStockByPath, setListStockByPath] = useState(null);
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [products_name, setProducts_name] = useState();
  const [initialLoading, setInitialLoading] = useState(true);
  const [totalTagsNumber, setTotalTagsNumber] = useState(0);

  const { loading, afterSubmit, beforeSubmit } = useRequest();

  const goBackModal = () => {
    history.push({
      pathname: "/admin/stock",
      state: { step: stepLocalizations }
    });
  };

  const handleSelectedItem = item => {
    setInitialLoading(false);
    setListStockByPath(null);
    if (item) {
      setMobilePanelOpen(false);
      setItemId(item.key);
      setTotalTagsNumber(0); // limpia temporalmente antes de nueva busqueda
      beforeSubmit();
      StockService.localization_product(item.key)
        .then(response => {
          afterSubmit();

          var i = 0,
            val,
            index,
            values = [],
            result = [];
          for (; i < response.length; i++) {
            if (response[i].stock.location) {
              val = response[i].stock.location.path;
            }else {
              val = i18n.t("in.transit");
            }
            index = values.indexOf(val);
            if (index > -1) result[index].push(response[i]);
            else {
              values.push(val);
              result.push([response[i]]);
            }
          }

          setListStockByPath(result);
          setTotalTagsNumber(response.length);
        })
        .catch(_ => {
          afterSubmit();
          setListStockByPath(null);
        });
    } else {
      setItemId(null);
      setListStockByPath(null);
      setTotalTagsNumber(0);
    }
  };

  const tableContentNew = (
    <div className={styles["outter-wrapper"]}>
      <Container className={styles["container-localization-products"]}>
        <LocalizationProductFilter handleApply={handleSelectedItem} />

        {itemId && (
          <div className={styles["grid-wrapper"]}>
            <Grid className={styles["grid-container"]}>
              <LocalizationProductItem
                itemId={itemId}
                totalTagsNumber={totalTagsNumber}
              />
            </Grid>
          </div>
        )}
        {listStockByPath && (
          <>
            {listStockByPath.map(item => {
              return <DropDownTags listTags={item} />;
            })}
          </>
        )}

        {!initialLoading && !listStockByPath && !loading && (
          <NotFoundItems />
        )}

        {initialLoading && (
          <div className={styles["initial-search-wrapper"]}>
            <img src={IconSearchProducts} alt="search products" className={styles["icon-search-products"]} />
            <div className={styles["text"]}>
              {i18n.t("search.by.product.or.category")}
            </div>
          </div>
        )}

      </Container>
    </div>
  );

  return (
    <div className={styles["load-locprod-container"]}>
      <AdminLayout
        headerTitle={i18n.t("product.location")}
        headerOptions={[]}
        content={tableContentNew}
        goBackFunc={goBackModal}
        navHidden={true}
      ></AdminLayout>

      <ErrorModal
        open={openErrorModal}
        message={errorMessage}
        handleGoBack={e => {
          setOpenErrorModal(false);
        }}
        handleClose={e => {
          setOpenErrorModal(false);
        }}
        handleAddLocalization={e => {
          history.push("/admin/businessnodes");
        }}
        handleButtonClick={e => {
          setOpenErrorModal(false);
        }}
      />

      {loading && <Loader />}
    </div>
  );
};

export default LocalizationProductView;
